import { Box, useTheme } from "@mui/material";
import { StyledCircularProgress, pickColor } from "./styled";
import { ICircularProgressProps } from "./types";

const clamp = (value: number) => Math.min(100, Math.max(0, value));

const CircularProgress = ({
    color = "primary",
    bufferValue,
    variant,
    value,
    ...props
}: ICircularProgressProps) => {
    const theme = useTheme();
    const palette = pickColor(theme)[color] ?? {};
    const bufferColor = palette.buffer ?? palette.main;

    // Se tiver bufferValue, renderizamos uma trilha secundária mais clara
    if (bufferValue !== undefined) {
        return (
            <Box position="relative" display="inline-flex">
                <StyledCircularProgress
                    variant="determinate"
                    value={clamp(bufferValue)}
                    customColor={color}
                    sx={{ position: "absolute", left: 0, top: 0, color: bufferColor }}
                    thickness={props.thickness}
                    size={props.size}
                />
                <StyledCircularProgress
                    variant={variant ?? "determinate"}
                    value={value}
                    customColor={color}
                    thickness={props.thickness}
                    size={props.size}
                    {...props}
                />
            </Box>
        );
    }

    return (
        <StyledCircularProgress
            variant={variant}
            value={value}
            customColor={color}
            {...props}
        />
    );
};

export { CircularProgress };

